module.exports = __webpack_public_path__ + "static/media/onboarding.40d6a252.gif";